import React from 'react';
import PropTypes from 'prop-types';
import {Chart, Line} from "react-chartjs-2";


const LineEqualizationChart = ({ result }) => {

  if (!result || Object.keys(result).length === 0){
    return (
      <div/>
    );
  }
  
  let chartOptions = {
    legend :{
      display:true,
      position:'right',
      fullWidth: false,
      labels :{
        fontSize: 8
      }
    }    
  }

  let datapoints = [   
    400,
    350,
    300,
    200,
    150,
    0
  ]

  let datapoints2 = [
    400,
    360,
    320,
    180,
    150,
    0
  ]

  let chartData = {
      datasets: [{
        data: datapoints,
        backgroundColor: [             
          '#ffff00'
        ],  
      },
      {
        data: datapoints2,
        backgroundColor: [             
          '#b3b3ff'
        ],  
      }]    
  };

  
  return (
    <Line data={chartData} options={chartOptions} width={400} height={200} />
  );
};

LineEqualizationChart.propTypes = {
    result: PropTypes.object,
};

export default LineEqualizationChart;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Charts/LineEqualizationChart.js